import React from "react";
import { Menu } from "lucide-react";
import "./Header.css";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useUser from "../../../hooks/useUser";

export default function Header({ onMenuClick, sidebarOpen }) {
  const { user } = useUser();
  const { t, i18n } = useTranslation('header');

  const changeLanguage = () => {
    i18n.changeLanguage(i18n.language === "es" ? "en" : "es");
  };

  return (
    <header className="owly-header">
      {/* Left side */}
      <div className="owly-header-left">
        {/* Botón hamburguesa solo en mobile (sidebar oculto) */}
        <button
          className="owly-header-menu-btn lg:hidden"
          onClick={onMenuClick}
          aria-label={sidebarOpen ? t('closeMenu') : t('openMenu')}
          style={{
            background: "none",
            border: "none",
            padding: 4,
            borderRadius: 6,
            cursor: "pointer",
            marginRight: 12,
          }}
        >
          {sidebarOpen ? (
            <svg width="22" height="22" viewBox="0 0 24 24">
              <path fill="currentColor" d="M18 6L6 18M6 6l12 12" />
            </svg>
          ) : (
            <Menu size={22} />
          )}
        </button>
        <div>
          <h2 className="owly-header-title">{t('title')}</h2>
          <p className="owly-header-desc">
            {t('description')}
          </p>
        </div>
      </div>

      {/* Right side */}
      <div className="flex items-center space-x-4">
      <button className="btn-banderas" onClick={changeLanguage} aria-label={t('toggleLanguage')}>
            {i18n.language === "es" ? (
              <img
                src="https://s.w.org/images/core/emoji/14.0.0/svg/1f1ea-1f1f8.svg"
                alt={t('flagEsAlt')}
                width={25}
                height={25}
              />
            ) : (
              <img
                src="https://s.w.org/images/core/emoji/14.0.0/svg/1f1fa-1f1f8.svg"
                alt={t('flagEnAlt')}
                width={25}
                height={25}
              />
            )}
          </button>
        <NavLink to="/app/profile" className="w-8 h-8 rounded-full flex items-center justify-center" style={{ textDecoration: 'none' }}>
          <span className="user-avatar">
            {user && user.username ? user.username.charAt(0) : "?"}
          </span>
        </NavLink>
      </div>
    </header>
  );
}
